var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPrescription = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M20.311 2.72a2.475 2.475 0 0 0-3.492.001l-7.455 7.437a3.35 3.35 0 0 0-.983 2.231l-.106 2.513A2.017 2.017 0 0 0 10.294 17h2.472c.907 0 1.777-.365 2.41-1.013l7.396-7.579a2.455 2.455 0 0 0-.023-3.459zm-2.54.95a1.125 1.125 0 0 1 1.588 0l2.238 2.229c.435.432.44 1.133.01 1.572l-1.485 1.517-3.844-3.828zm-2.445 2.44-5.01 4.997a2 2 0 0 0-.589 1.339l-.106 2.512c-.016.382.29.7.673.7h2.472c.544 0 1.066-.22 1.446-.608l4.97-5.1z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: 1.5,
  d: "M21.273 13v4a5 5 0 0 1-5 5h-8a5 5 0 0 1-5-5V9a5 5 0 0 1 5-5h4"
})));
export default SvgPrescription;